import { areaChartOptions } from './area-chart.options';
import { arearangeChartOptions } from './arearange-chart.options';
import { areasplineChartOptions } from './areaspline-chart.options';
import { areasplinerangeChartOptions } from './areasplinerange-chart.options';
import { barChartOptions } from './bar-chart.options';
import { baseChartOptions } from './base-chart.options';
import { columnChartOptions } from './column-chart.options';
import { columnrangeChartOptions } from './columnrange-chart.options';
import { lineChartOptions } from './line-chart.options';
import { packedbubbleChartOptions } from './packedbubble-chart.options';
import { pieChartOptions } from './pie-chart.options';
import { sankeyChartOptions } from './sankey-chart.options';
import { scatterChartOptions } from './scatter-chart.options';
import { splineChartOptions } from './spline-chart.options';
import { splitbubbleChartOptions } from './splitbubble-chart.options';

// Chart type mapping for easy access
export const ChartOptions = {
    base: baseChartOptions,
    line: lineChartOptions,
    spline: splineChartOptions,
    area: areaChartOptions,
    area_spline: areasplineChartOptions,
    column: columnChartOptions,
    bar: barChartOptions,
    pie: pieChartOptions,
    scatter: scatterChartOptions,
    area_range: arearangeChartOptions,
    area_spline_range: areasplinerangeChartOptions,
    column_range: columnrangeChartOptions,
    sankey: sankeyChartOptions,
    packed_bubble: packedbubbleChartOptions,
    split_bubble: splitbubbleChartOptions
};
